(function () {
  'use strict';

  angular
      .module('tfc.Help', [])
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('help', {
          parent : 'pageWithMenu',
          url : '/contact',
          templateUrl : 'Help/Help.tmpl.html',
          controller : 'HelpCtrl as vm',
          data:{
            requireTerms:false,
            title:'Help',
            path:'contact'
          }
        })
  }

})();